import React, { useCallback, useMemo } from 'react'
import Slider from "react-slick";
import useApi from '../../hook/useApi';
import { useNavigate } from '../../hook/useNavigate';

const isDev = process.env.NODE_ENV !== 'production';
const cashUrl = isDev ? 'http://localhost:3000/cash' : 'https://play.ztpoker.com/cash';

const mobileSettings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const desktopSettings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
};

const LiveToken = ({ metrics }) => {
    const { navNewTab } = useNavigate();
    const { data: tables, loading } = useApi(
        'POST',
        'table-types',
        {
            gameFormat: 'cash',
        },
        {
            refetchInterval: 1000 * 60 * 10,
        }
    );

    const handlePlayNow = useCallback(() => {
        navNewTab(cashUrl)
    }, [navNewTab]);

    const renderTable = useCallback((table, index) => {
        return (
            <div key={index} className="col-lg-4 col-md-6 top-reveal">
                <div className="live-tokent-box">
                    <div className='game-name'>
                        <p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                <path d="M9.65625 3.3125C10.0125 3.09375 10.25 2.69687 10.25 2.25C10.25 1.55937 9.69063 1 9 1C8.30937 1 7.75 1.55937 7.75 2.25C7.75 2.7 7.9875 3.09375 8.34375 3.3125L6.55312 6.89375C6.26875 7.4625 5.53125 7.625 5.03438 7.22813L2.25 5C2.40625 4.79063 2.5 4.53125 2.5 4.25C2.5 3.55938 1.94062 3 1.25 3C0.559375 3 0 3.55938 0 4.25C0 4.94062 0.559375 5.5 1.25 5.5C1.25625 5.5 1.26562 5.5 1.27188 5.5L2.7 13.3562C2.87188 14.3062 3.7 15 4.66875 15H13.3313C14.2969 15 15.125 14.3094 15.3 13.3562L16.7281 5.5C16.7344 5.5 16.7437 5.5 16.75 5.5C17.4406 5.5 18 4.94062 18 4.25C18 3.55938 17.4406 3 16.75 3C16.0594 3 15.5 3.55938 15.5 4.25C15.5 4.53125 15.5938 4.79063 15.75 5L12.9656 7.22813C12.4688 7.625 11.7312 7.4625 11.4469 6.89375L9.65625 3.3125Z" fill="#F59E0B" />
                            </svg>
                            {table.name}
                        </p>
                        <h6>{`${table.small} ZTGM / ${table.big} ZTGM`}</h6>
                    </div>
                    <div className="game-table">
                        <p>Buy-in:</p>
                        <h6>{`${table.minBuyIn} ZTGM`}</h6>
                    </div>
                    <button onClick={handlePlayNow} className='btn btn-base'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                            <g clip-path="url(#clip0_1_124)">
                                <path d="M2.85547 1.0664C2.45078 0.817568 1.94219 0.809365 1.5293 1.04179C1.11641 1.27421 0.859375 1.71171 0.859375 2.18749V11.8125C0.859375 12.2883 1.11641 12.7258 1.5293 12.9582C1.94219 13.1906 2.45078 13.1797 2.85547 12.9336L10.7305 8.12108C11.1215 7.88319 11.3594 7.45937 11.3594 6.99999C11.3594 6.54062 11.1215 6.11952 10.7305 5.8789L2.85547 1.0664Z" fill="white" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1_124">
                                    <path d="M0.859375 0H11.3594V14H0.859375V0Z" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        Play Now
                    </button>
                </div>
            </div>)
    }, []);

    if (loading || !tables) {
        return <></>
    }

    return (
        <div id='playnow' className="live-tokent-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title">
                            <h2 className='right-reveal'>Live Token Cash Tables</h2>
                            <p className='right-reveal'>Join live poker tables and start playing instantly</p>
                            <div className="left-reveal number-text" style={{ margin: "5px" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none">
                                    <g clip-path="url(#clip0_1_146)">
                                        <path d="M3.9375 0C4.51766 0 5.07406 0.230468 5.4843 0.640704C5.89453 1.05094 6.125 1.60734 6.125 2.1875C6.125 2.76766 5.89453 3.32406 5.4843 3.7343C5.07406 4.14453 4.51766 4.375 3.9375 4.375C3.35734 4.375 2.80094 4.14453 2.3907 3.7343C1.98047 3.32406 1.75 2.76766 1.75 2.1875C1.75 1.60734 1.98047 1.05094 2.3907 0.640704C2.80094 0.230468 3.35734 0 3.9375 0ZM14 0C14.5802 0 15.1366 0.230468 15.5468 0.640704C15.957 1.05094 16.1875 1.60734 16.1875 2.1875C16.1875 2.76766 15.957 3.32406 15.5468 3.7343C15.1366 4.14453 14.5802 4.375 14 4.375C13.4198 4.375 12.8634 4.14453 12.4532 3.7343C12.043 3.32406 11.8125 2.76766 11.8125 2.1875C11.8125 1.60734 12.043 1.05094 12.4532 0.640704C12.8634 0.230468 13.4198 0 14 0ZM0 8.16758C0 6.55703 1.30703 5.25 2.91758 5.25H4.08516C4.51992 5.25 4.93281 5.3457 5.30469 5.51523C5.26914 5.71211 5.25273 5.91719 5.25273 6.125C5.25273 7.16953 5.71211 8.10742 6.43672 8.75C6.43125 8.75 6.42578 8.75 6.41758 8.75H0.582422C0.2625 8.75 0 8.4875 0 8.16758ZM11.0824 8.75C11.077 8.75 11.0715 8.75 11.0633 8.75C11.7906 8.10742 12.2473 7.16953 12.2473 6.125C12.2473 5.91719 12.2281 5.71484 12.1953 5.51523C12.5672 5.34297 12.9801 5.25 13.4148 5.25H14.5824C16.193 5.25 17.5 6.55703 17.5 8.16758C17.5 8.49023 17.2375 8.75 16.9176 8.75H11.0824ZM6.125 6.125C6.125 5.42881 6.40156 4.76113 6.89384 4.26884C7.38613 3.77656 8.05381 3.5 8.75 3.5C9.44619 3.5 10.1139 3.77656 10.6062 4.26884C11.0984 4.76113 11.375 5.42881 11.375 6.125C11.375 6.82119 11.0984 7.48887 10.6062 7.98116C10.1139 8.47344 9.44619 8.75 8.75 8.75C8.05381 8.75 7.38613 8.47344 6.89384 7.98116C6.40156 7.48887 6.125 6.82119 6.125 6.125ZM3.5 13.2699C3.5 11.2574 5.13242 9.625 7.14492 9.625H10.3551C12.3676 9.625 14 11.2574 14 13.2699C14 13.6719 13.6746 14 13.2699 14H4.23008C3.82812 14 3.5 13.6746 3.5 13.2699Z" fill="#3B82F6" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1_146">
                                            <path d="M0 0H17.5V14H0V0Z" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                {`${metrics?.currentOnlinePlayers || 0} players online`}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-none d-md-block">
                    <div className="row row-gap-4 justify-content-center ">
                        <Slider  {...desktopSettings}>
                            {tables.map((table, index) => (
                                renderTable(table, index)
                            ))}
                        </Slider>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 d-md-none">
                        <Slider {...mobileSettings}>
                            {tables.map((table, index) => (
                                renderTable(table, index)
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LiveToken